export const regularUserCasualUsersTableHeaders = [
  {
    text: 'Associate',
    value: 'isBounded',
    align: 'center',
    class: 'bg-table-heading table-header-first',
    width: '30px',
    sortable: false,
  },
  {
    text: 'Username',
    value: 'email',
    align: 'start',
    class: 'bg-table-heading',
    width: '50%',
  },
  {
    text: 'Name',
    value: 'name',
    align: 'start',
    class: 'bg-table-heading',
    width: '23%',
  },
  {
    text: 'Associated',
    value: 'boundedUsers.length',
    align: 'center',
    width: '60px',
    class: 'bg-table-heading',
  },
  {
    text: 'Creator',
    value: 'addedBy.email',
    align: 'center',
    class: 'bg-table-heading',
    width: '200px',
  },

  {
    text: 'S/N',
    value: 'casualUserId',
    align: 'center',
    width: '60px',
    class: 'bg-table-heading table-header-last',
  },
]
